import(/* webpackMode: "eager" */ "/vercel/path0/src/app/manufacturing/page.tsx");
